<template>
	<div class="Footer">
		<van-tabbar v-model="tempActive" active-color="#fe8a00" inactive-color="#67676" z-index="999"
			@change="parentHandleclick">
			<van-tabbar-item>
				<span>首页</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icon1.active : icon1.inactive" />
			</van-tabbar-item>
			<van-tabbar-item>
				<span>我的</span>
				<img slot="icon" slot-scope="props" :src="props.active ? icon2.active : icon2.inactive" />
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'Footer',
		props: {
			active: Number
		},
		data() {
			return {
				icon1: {
					active: require('../assets/home-on.png'),
					inactive: require('../assets/home-off.png')
				},
				icon2: {
					active: require('../assets/my-on.png'),
					inactive: require('../assets/my-off.png')
				},
				tempActive: this.active
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		methods: {
			parentHandleclick(index) {
				if (index === 0) {
					this.tempActive = 0
					this.$router.push({
						path: '/'
					})
				}
				if (index === 1) {
					if (this.userInfo && this.userInfo.userId) {
						this.tempActive = 1
						this.$router.push({
							path: '/my'
						})
					} else {
						this.$emit('need-login')
						this.tempActive = this.active != null ? this.active : 0
					}
				}
			}
		},
	}
</script>

<style>
</style>
